import React from 'react';
import { Brain } from 'lucide-react';
import WhyPanel from './WhyPanel';

/**
 * MentalWhyPanel — synthesized WHY for the /mental page. Reads `mental_insight`
 * from /api/wellness/iq (built by compute_mental_insight in wellness.py). Same
 * shape + look as Recovery/Movement Why panels.
 */
const MentalWhyPanel = ({ insight, score, onActionClick, actionLabel }) => (
  <WhyPanel
    insight={insight}
    icon={Brain}
    color="#a855f7"
    title={`WHY YOUR MENTAL IS${score != null ? '' : ' WHERE IT IS'}`}
    score={score}
    testIdPrefix="mental-why-panel"
    onActionClick={onActionClick}
    actionLabel={actionLabel}
    emptyMessage="I need today's check-in first — mood, stress, and sleep. Tap through it and I'll tell you the one thing worth doing for your headspace."
  />
);

export default MentalWhyPanel;
